import { render, staticRenderFns } from "./InformacoesGeraisBP.vue?vue&type=template&id=6c282aac&scoped=true"
import script from "./InformacoesGeraisBP.vue?vue&type=script&lang=js"
export * from "./InformacoesGeraisBP.vue?vue&type=script&lang=js"
import style0 from "./InformacoesGeraisBP.vue?vue&type=style&index=0&id=6c282aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c282aac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
